import ChooseCorrectHome from "../../components/UKG/GeneralAwareness/ChooseCorrectHome";
import ChooseHomeItems from "../../components/UKG/GeneralAwareness/ChooseHomeItems";
import MyHomeTrueFalse from "../../components/UKG/GeneralAwareness/MyHomeTrueFalse";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/ukg/general-awareness/my-home/choose-correct-answer", title: "Choose Correct", component: ChooseCorrectHome},
    { url: "/ukg/general-awareness/my-home/true-false", title: "True & False", component: MyHomeTrueFalse},
    { url: "/ukg/general-awareness/my-home/choose-correct-image", title: "Choose Image", component: ChooseHomeItems},
];


export default topics;